import React from 'react';
import { NumberInput } from '..';
import { Box, Button } from '@mui/material';
import { TypographyStyled } from './styles';
import { PlaceholderGrid } from '../../../../styles/globalStyles';
import infoIcon from '../../../../assets/icons/infoIcon.svg';

export const SingleNumberCard = ({
  width,
  marginVal,
  title,
  subHead,
  plusSymbolRequired,
  decimalRequired,
  incrementDecrementVal,
  value,
  range,
  infoIconVal,
  setValue,
  infoIconClick
}: {
  width?: string;
  marginVal?: string;
  title?: string;
  subHead?: string;
  value: number;
  decimalRequired?: boolean;
  incrementDecrementVal?: number;
  plusSymbolRequired?: boolean;
  infoIconVal?: boolean;
  range?: { min: number; max: number };
  setValue: (val: number) => void;
  infoIconClick?: () => void;
}) => {
  return (
    <PlaceholderGrid
      container
      sx={{ width: width || '100%' }}
      marginRight={marginVal}
    >
      <Box display={'flex'} flexDirection={'row'}>
        <TypographyStyled
          variant="h6"
          sx={{
            fontSize: '0.875rem',
            lineHeight: '1.125rem',
            fontFamily: 'BGBold'
          }}
        >
          {title}
        </TypographyStyled>
        {infoIconVal && (
          <Button
            onClick={infoIconClick}
            sx={{ height: '1.25rem', minWidth: '1.25rem', padding: 0 }}
          >
            <img src={infoIcon} alt={'infoIcon'} />
          </Button>
        )}
      </Box>
      <NumberInput
        subHeading={subHead}
        decimalRequired={decimalRequired}
        incrementDecrementVal={incrementDecrementVal}
        plusSymbolRequired={plusSymbolRequired}
        value={value}
        setValue={setValue}
        range={range}
      />
    </PlaceholderGrid>
  );
};
